(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('TipoOrdenamientoDetailController', TipoOrdenamientoDetailController);

    TipoOrdenamientoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TipoOrdenamiento', 'Norma'];

    function TipoOrdenamientoDetailController($scope, $rootScope, $stateParams, previousState, entity, TipoOrdenamiento, Norma) {
        var vm = this;

        vm.tipoOrdenamiento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('sgnmrApp:tipoOrdenamientoUpdate', function(event, result) {
            vm.tipoOrdenamiento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
